<!--
 * @Author: guoyu
 * @Date: 2021-04-21 10:48:59
 * @LastEditors: your name
 * @LastEditTime: 2021-04-27 17:05:22
 * @Description: 用戶分享出去的邀請頁面
-->
<template>
  <div class="invite-resgister">
    <div class="title-logo"></div>
    <div class="layout-center">
      <div class="share-avatar">
        <fps-avatar class="avatar" :src="shareUser.avatarUrl"></fps-avatar>
      </div>
      <p class="nick-name">{{ shareUser.nickname || '測試數據' }}</p>
      <p class="invite-tip">送您多張優惠券，並邀您一起玩遊戲！</p>
      <div class="red-bag">
        <div class="register-button" @click="sginUp"></div>
      </div>
    </div>
    <div class="nicee-tag"></div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      shareUser: {}
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    getInviteUser() {
      this.$http.get('/signUp/getUserInfoByUniqueCode', {signUpUniqueCode: this.$route.params.inviteCode}).then(({data})=>{
        this.shareUser = data
      }).catch((e)=>{
        this.$router.push({
          path: '/'
        })
        this.$message.error('邀請連結錯誤：' + e.msg)
        console.error(e)
      })
    },
    sginUp() {
      if(this.userInfo) {
        this.$message.warning('該設備已註冊,請使用新的註冊設備');
        this.$router.push({path: '/'})
        return
      }
      this.$util.Login()
    }
  },
  created() {
    this.$adjust('invitelink_click', {inviteCode: this.$route.params.inviteCode})
    sessionStorage.setItem('signUpUniqueCode', this.$route.params.inviteCode)
    this.getInviteUser()
  }
};
</script>
<style lang="scss" scoped>
.invite-resgister {
  position: relative;
  width: 624px;
  height: 726px;
  margin: 40px auto 0;
  overflow: hidden;
  background: #0f122c url(./images/bg-img.jpg) no-repeat left top;
  background-size: 100% auto;
}
.title-logo {
  height: 36px;
  margin: 36px 24px;
  background: url(./images/nicee-logo.png) no-repeat left top;
  background-size: auto 36px;
}
.layout-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 38px;
}
.share-avatar {
  height: 135px;
  width: 135px;
  padding: 12px;
  background: url(./images/avatar-circle.png) no-repeat;
  background-size: 100% 100%;
}
.avatar {
  height: 100%;
  width: 100%;
}
.nick-name {
  margin: 18px auto 8px;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #ffffff;
}
.invite-tip {
  margin-bottom: 40px;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
}
.red-bag {
  position: relative;
  width: 263px;
  height: 227px;
  background: url(./images/red-pocket.png) no-repeat;
  background-size: 100% 100%;
}
.register-button {
  position: absolute;
  width: 183px;
  height: 63px;
  top: 140px;
  left: 50%;
  transform: translateX(-50%);
  background: url(./images/register-button.png) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.nicee-tag {
  position: absolute;
  height: 12px;
  width: 66px;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: url(./images/nicee-tag.png) no-repeat center;
  background-size: 66px 12px;
}
@media screen and (max-width: 599px) {
  .invite-resgister {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow: auto;
  }
  .red-bag {
    margin-bottom: 60px;
  }
  .nicee-tag {
    position: relative;
  }
}
</style>
